<script>
	import { Router, Route } from "svelte-routing";
	import MainBlackoutManagement from "./Manage/MainBlackoutManagement.svelte";
	import CreateBlackoutForm from "./CreateBlackoutForm.svelte";
	import SelectCar from "./Manage/MainCarManagement.svelte";
	import EditBlackoutForm from "./EditBlackoutForm.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainBlackoutManagement} />
	<Route path="/create" component={CreateBlackoutForm} />
	<Route path="/create/select-car" component={SelectCar} />
	<Route path="/edit/:id" let:params>
		<EditBlackoutForm blackoutId={params.id} />
	</Route>
</Router>
